<div
  [ngClass]="{'seller--small': mode === 'small', 'seller--medium': mode === 'medium'}" class="seller">
  <div
    *ngIf="isImageExist"
    [ngStyle]="{'background-image': 'url(\'' + imageUrl + '\')'}"
    class="seller__logo">
  </div>
  <img
    (error)="onError()"
    *ngIf="imageUrl"
    [alt]="fullName"
    [src]="imageUrl"
    hidden>
  <div
    *ngIf="!isImageExist || !imageUrl"
    class="seller__abbreviation">
    {{ abbreviation }}
  </div>
</div>


